import { v4 } from 'uuid'

export const buildUuid = (): string => {
  return v4().substring(0, 18)
}
